import { render, staticRenderFns } from "./SleepOneblock.vue?vue&type=template&id=1f7bfa81"
import script from "./SleepOneblock.vue?vue&type=script&lang=js"
export * from "./SleepOneblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports